import React from 'react';
import styles from './PageBackground.module.scss';
import Image from 'next/legacy/image';
import cx from 'classnames';

export default function PageBackground({
  imageUrl,
  width,
  height,
  flip = false,
  withBreadcrumbs = false,
}: {
  imageUrl: string;
  width: number;
  height: number;
  flip?: boolean;
  withBreadcrumbs?: boolean;
}): JSX.Element {
  return (
    <div
      className={cx({
        [styles.wrapper]: true,
        [styles.wrapperWithBreadcrumbs]: withBreadcrumbs,
      })}
    >
      <Image
        src={imageUrl}
        alt=''
        className={flip ? styles.imageFlipped : ''}
        width={width}
        height={height}
      />
    </div>
  );
}
